// @flow
import * as React from 'react';

type ClientAttributionProps = {
  clientId: string,
  clientName: ?string,
  copy: string,
};

const IMAGE_HOST = `//${process.env.BUILD_ENV_PREFIX ||
  ''}images.powerreviews.com`;

class ClientAttribution extends React.PureComponent<
  ClientAttributionProps,
  void
> {
  brandImage: ?HTMLImageElement;

  showDefaultBrandImage = () => {
    if (this.brandImage) {
      this.brandImage.src =
        'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    }
  };

  render() {
    const imageStyle = {
      maxWidth: '60px',
      height: 'auto',
    };
    return (
      <div className="flex bg-white items-center pa3">
        <div>
          <img
            style={imageStyle}
            src={`${IMAGE_HOST}/images_merchants/logos/${
              this.props.clientId
            }_logo_large.png`}
            alt={this.props.clientName}
            ref={c => (this.brandImage = c)}
            onError={this.showDefaultBrandImage}
          />
        </div>
        <div className="ml2">
          <div className="f6 gray arial">{this.props.copy}</div>
          <span className="f5 b brandon">
            {this.props.clientName
              ? this.props.clientName
              : 'PowerReviews Network'}
          </span>
        </div>
      </div>
    );
  }
}

type Props = {
  clientId: string,
  clientName: ?string,
  ugctype: string,
};

export function BrandAttribution(props: Props) {
  return (
    <ClientAttribution
      clientId={props.clientId}
      clientName={props.clientName}
      copy={`${getUgcTypeLabel(props.ugctype)} from`}
    />
  );
}

export function RetailerAttribution(props: Props) {
  return (
    <ClientAttribution
      clientId={props.clientId}
      clientName={props.clientName}
      copy={`${props.ugctype} Source`}
    />
  );
}

/*
 * We present friendlier ugctype labels by mapping
 * BrandAnswer & BrandMerchantResponse to Answer & Response respectively
 */
function getUgcTypeLabel(ugctype) {
  if (ugctype === 'BrandAnswer') {
    return 'Answer';
  } else if (ugctype === ('BrandMerchantResponse': ResponseUgcType)) {
    return 'Response';
  } else {
    return ugctype;
  }
}



// WEBPACK FOOTER //
// ./src/components/ClientAttribution/ClientAttribution.js